import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../tab/index.css';
import '../../sticky/index.css';
import '../../tabs/index.css';
import '../index.css';